export default "__VITE_ASSET__491c64bf__"